import { ProcessedDistributionPoint } from '../types/types';
import { UI } from '../constants';

export const scrollToTop = () => {
  if (window.innerWidth <= UI.MOBILE_BREAKPOINT) {
    window.scrollTo(0, 0);
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

export function filterText(text: string): string {
  if (!text) return '';
  const withoutHtml = text.replace(/<[^>]*>/g, '');
  return withoutHtml.trim();
}

export function calculatePercentileFromCurve(
  score: number,
  curvePoints: ProcessedDistributionPoint[]
): number | undefined {
  if (!curvePoints || curvePoints.length === 0) {
    return undefined;
  }

  const sortedPoints = [...curvePoints].sort((a, b) => a.score - b.score);

  if (score < sortedPoints[0].score) {
    return sortedPoints[0].percentile;
  }
  if (score > sortedPoints[sortedPoints.length - 1].score) {
    return sortedPoints[sortedPoints.length - 1].percentile;
  }

  let lowerPoint = sortedPoints[0];
  let upperPoint = sortedPoints[sortedPoints.length - 1];

  for (let i = 0; i < sortedPoints.length; i++) {
    if (sortedPoints[i].score === score) {
      return sortedPoints[i].percentile;
    }
    if (
      sortedPoints[i].score < score &&
      sortedPoints[i + 1] &&
      sortedPoints[i + 1].score > score
    ) {
      lowerPoint = sortedPoints[i];
      upperPoint = sortedPoints[i + 1];
      break;
    }
  }

  const scoreRange = upperPoint.score - lowerPoint.score;
  if (scoreRange === 0) {
    return lowerPoint.percentile;
  }

  const percentileRange = upperPoint.percentile - lowerPoint.percentile;
  const scorePosition = (score - lowerPoint.score) / scoreRange;
  const interpolatedPercentile =
    lowerPoint.percentile + scorePosition * percentileRange;

  return interpolatedPercentile;
}

export function formatDate(date: Date): string {
  return date.toISOString().split('T')[0];
}
